import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { ItemTypesComponent } from '@emm/management/components/item-types/item-types.component';

@Injectable({
    providedIn: 'root'
})
export class ConfirmItemTypesDeactivateGuard  {

    canDeactivate(
        component: ItemTypesComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return component
            .checkIfItemHasChanges(component.prevItemType)
            .pipe(take(1));
    }

}
